import { createSlice } from "@reduxjs/toolkit";
import { getChefRatingReviewAPI } from "../../api/ratingreview";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getChefRatingReviewSlice = createSlice({
  name: "getChefRatingReview",
  initialState: data,
  reducers: {
   getChefRatingReviewSlice(state) {
      state.isLoading = true;
    },
   getChefRatingReviewSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getChefRatingReviewSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getChefRatingReviewSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getChefRatingReviewHandler = (search:any,page:any,limit:any,sort_by:any,sort_direction:any) => async (dispatch: any) => {
  try {
    dispatch(getChefRatingReviewAction.getChefRatingReviewSlice());
    const response: any = await getChefRatingReviewAPI(search,page,limit,sort_by,sort_direction);
    
    dispatch(getChefRatingReviewAction.getChefRatingReviewSliceSuccess(response));
  } catch (e: any) {
    dispatch(getChefRatingReviewAction.getChefRatingReviewSliceFailure(e?.response?.data));
  }
};
export default getChefRatingReviewSlice.reducer;
export const getChefRatingReviewAction = getChefRatingReviewSlice.actions;
